angular.module("riscattoTermine.components", []).component("riscattoTermine", {
    templateUrl: "ng/components/riscattoTermine/riscattoTermine.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "riscattoTermineCtrl",
    controller: function RiscattoTermine(
        $typeDomainService,
        $arcService,
        $modalService,
        $RichiestePostVenditaService,
        $location,
        $rootScope
    ) {
        var self = this;

        self.onInit = function () {
            self.supportModel = {
                fatturazioneOk: false,
                infoLicenzaNoleggio: false
            }
            self.richiestePostVendita.metadata.riscattoATermine.textRiscSi = self.richiestePostVendita.metadata.riscattoATermine.textRiscSi && self.richiestePostVendita.metadata.riscattoATermine.textRiscSi.replace(/\n/gi, '<br/>');
            self.richiestePostVendita.metadata.riscattoATermine.textRiscNo = self.richiestePostVendita.metadata.riscattoATermine.textRiscNo && self.richiestePostVendita.metadata.riscattoATermine.textRiscNo.replace(/\n/gi, '<br/>');
            if (!self.richiestePostVendita.typeWf || !self.richiestePostVendita.applicationName) {
                self.richiestePostVendita.typeWf = "WF_POSTVENDITA";
                self.richiestePostVendita.applicationName = "RISCATTO_TERMINE";
            }

            self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato =
                self.richiestePostVendita.ctrRichiestaList[0].cluster === "TARGATO" ? true : false;

            self.richiestePostVendita.metadata.riscattoATermine.prodottoImm =
                self.richiestePostVendita.ctrRichiestaList[0].cluster === "IMMOBILIARE" ? true : false;

            self.richiestePostVendita.metadata.riscattoATermine.prodottoNav =
                self.richiestePostVendita.ctrRichiestaList[0].cluster === "AEREONAVALE" || self.richiestePostVendita.ctrRichiestaList[0].cluster === "AERONAUTICO" ? true : false;

            self.visibleDownloadChecklist = true;
            self.visibleUploadChecklist = true;

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                self.getStepInfoDetails();
                callRestInfoCcBank();
                if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                    self.popoleteCheckList();
                } else {
                    self.popolateCheckListDownload();
                    self.popolateCheckListUpload();
                }
            }

            retrieveStepInfo();
        }

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.riscattoATermine.allegati.length > 0) {
                self.richiestePostVendita.metadata.riscattoATermine.allegati.push(value);
            } else {
                self.richiestePostVendita.metadata.riscattoATermine.allegati[0] = value;
            }
        }

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.validateComponent = function (validity) {
            self.validityComponent = validity;
        }

        self.nextValidity = function () {
            return self.validityComponent;
        }

        self.validateFirmatario = function (validity, buttonPress) {
            self.validityFirmatario = validity;
            self.validateFirmatarioPage();
            if (validity && buttonPress) {
                self.next();
            }
        }

        self.validateFirmatarioPage = function () {
            self.validityComponent = self.validityFirmatario;
            self.nextValidity();

        }

        self.firmaChangedFn = function () {
            self.firmaChanged = !self.firmaChanged;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'RA2') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.next = function (fromModal) {
            self.enabledLoader = true;
            switch (self.getWizardMap(self.richiestePostVendita.viewIndex)) {
                case 'RA2':
                    if (self.richiestePostVendita.metadata.riscattoATermine.accepted) {
                        if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                            $arcService
                                .acceptRiscTermine(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    if (response.success) {
                                        $RichiestePostVenditaService
                                            .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                            .then(function (response) {
                                                self.enabledLoader = false;
                                                self.richiestePostVendita.viewIndex = response.viewIndex;
                                                retrieveStepInfo();
                                                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                                    self.getStepInfoDetails();
                                                    callRestInfoCcBank();
                                                    if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                                                        self.popoleteCheckList();
                                                    } else {
                                                        self.popolateCheckListDownload();
                                                        self.popolateCheckListUpload();
                                                    }
                                                }
                                            })
                                            .catch(function (error) {
                                                console.log(error);
                                                self.enabledLoader = false;
                                            });
                                    } else {
                                        self.enabledLoader = false;
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                })


                        } else {
                            $RichiestePostVenditaService
                                .generateAllegatiPv(self.richiestePostVendita)
                                .then(function (response) {
                                    if (response.success) {
                                        $RichiestePostVenditaService
                                            .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                            .then(function (response) {
                                                self.enabledLoader = false;
                                                self.richiestePostVendita.viewIndex = response.viewIndex;
                                                retrieveStepInfo();
                                                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                                    self.getStepInfoDetails();
                                                    callRestInfoCcBank();
                                                    if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                                                        self.popoleteCheckList();
                                                    } else {
                                                        self.popolateCheckListDownload();
                                                        self.popolateCheckListUpload();
                                                    }
                                                }
                                            })
                                            .catch(function (error) {
                                                console.log(error);
                                                self.enabledLoader = false;
                                            });
                                    } else {
                                        self.enabledLoader = false;
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });
                        }


                    } else {
                        if (fromModal) {
                            self.loaderButtonModal = true;
                            $arcService
                                .declinaRiscatto(self.richiestePostVendita)
                                .then(function (response) {
                                    if (response.success) {
                                        $modalService.closeModal("preDeclineRiscTerm-modal");
                                        $rootScope.$broadcast("addAlert", {
                                            text: "DECLINE_RISC_TERM",
                                        });
                                        $location.path('/');
                                    }
                                    self.loaderButtonModal = false;
                                    self.enabledLoader = false;
                                })
                                .catch(function (error) {
                                    $rootScope.$broadcast("addAlert", {
                                        text: "ERROR_TEC",
                                    });
                                    self.loaderButtonModal = false;
                                })
                        } else {
                            $modalService.openModal("preDeclineRiscTerm-modal");
                        }

                    }
                    break;
                case 'RCKCLI':
                case 'RCKCLITER':
                    $RichiestePostVenditaService
                        .submitriscattoATermine(self.richiestePostVendita.metadata.riscattoATermine, self.richiestePostVendita.id, self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                        .then(function (response) {
                            if (response.success) {
                                $rootScope.$broadcast("addAlert", {
                                    text: "SUBMITTED_RISC_TERMINE"
                                })
                                $location.path('/');
                            }
                            self.enabledLoader = false;

                        }).catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });
                    break;
                case "RA4":
                    self.enabledLoader = true;
                    $RichiestePostVenditaService
                        .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                        .then(function (response) {
                            self.enabledLoader = false;
                            self.richiestePostVendita = response;
                            retrieveStepInfo();
                            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                self.getStepInfoDetails();
                                callRestInfoCcBank();
                                if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                                    self.popoleteCheckList();
                                } else {
                                    self.popolateCheckListDownload();
                                    self.popolateCheckListUpload();
                                }
                            }
                            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                                callgetSignSelectionInfo();
                                self.richiestePostVendita.metadata.riscattoATermine.firmaDigitaleEsterna = true;
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });

                    break;

                default:
                    self.enabledLoader = true;
                    $RichiestePostVenditaService
                        .generateAllegatiPv(self.richiestePostVendita)
                        .then(function (response) {
                            if (response.success) {
                                $RichiestePostVenditaService
                                    .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                    .then(function (response) {
                                        self.enabledLoader = false;
                                        self.richiestePostVendita = response;
                                        retrieveStepInfo();
                                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                            self.getStepInfoDetails();
                                            callRestInfoCcBank();
                                            if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato || self.richiestePostVendita.metadata.riscattoATermine.prodottoImm || self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                                                self.popoleteCheckList();
                                            } else {
                                                self.popolateCheckListDownload();
                                                self.popolateCheckListUpload();
                                            }
                                        }
                                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                                            callgetSignSelectionInfo();
                                            self.richiestePostVendita.metadata.riscattoATermine.firmaDigitaleEsterna = true;
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                        self.enabledLoader = false;
                                    });
                            } else {
                                self.enabledLoader = false;
                            }

                        }).catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });
                    break;
            }
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.back = function () {
            $RichiestePostVenditaService
                .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function (response) {
                    self.enabledLoader = false;
                    self.richiestePostVendita = response;
                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                })
        }

        self.closeModal = function (id) {
            self.enabledLoader = false;
            $modalService.closeModal(id);
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }

        var callgetSignSelectionInfo = function () {
            $arcService.getSignSelectionInfo(self.richiestePostVendita.id)
                .then(function (response) {
                    self.showSignMode = response.signModeVisible;
                    self.digitalSignOnly = response.digitalSignOnly;
                })
                .catch(function (error) {

                })
        };

        self.popoleteCheckList = function () {
            self.restUploadRunning = true;
            $arcService.checklistPv(self.richiestePostVendita)
                .then(function (response) {
                    console.log("Checklist postVendita:", response)
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.messageUpload = response.messageUpload;
                    self.messageDownload = response.messageDownload;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.getStepInfoDetails = function () {
            $arcService.getStepInfoDetails(self.richiestePostVendita)
                .then(function (response) {
                    self.stepInfDetailsResponse = response;
                })
                .catch(function (error) {
                    console.error(error);
                })

        }

        self.fattElettronica = function (fattElettronica, value) {
            if (fattElettronica) {
                self.richiestePostVendita.metadata.riscattoATermine.terzo.sedeFatturazione.fatturazione = fattElettronica;
                self.supportModel.fatturazioneOk = value;
                checkValidity();
            }
        }
        self.validateComponentInfoLicenzaNoleggio = function (value) {
            self.supportModel.infoLicenzaNoleggio = value;
            checkValidity();
        }

        self.handleCervedInfos = function (value, riUserG) {
            self.richiestePostVendita.metadata.riscattoATermine.terzo = riUserG;
            checkValidity();
        }

        var checkValidity = function () {
            self.validityComponent = self.supportModel.fatturazioneOk &&
                !self.richiestePostVendita.metadata.riscattoATermine.terzo.datiIncompleti &&
                (self.supportModel.infoLicenzaNoleggio || !self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio);
            self.nextValidity();

        }

        var callRestInfoCcBank = function () {

            $arcService.ibanRiscAnt(self.richiestePostVendita.id)
                .then(function (element) {
                    console.log(element);
                    self.modelCcBancarie = element;
                })
        }
    }
})